import { render, staticRenderFns } from "./MessageEditorView.vue?vue&type=template&id=cec7c2e0&"
import script from "./MessageEditorView.vue?vue&type=script&lang=ts&"
export * from "./MessageEditorView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports